/**
 * @file paddlejs overview
 * @author wanzhongyun
 */

import React from 'react';
import { IPaddleJsOverview } from './../../type';

import './style.less';

const PaddleJSOverview: React.FC<IPaddleJsOverview> = props => {

    const { title, desc, image, btnWord, bthLink } = props;

    return (
        <div className='paddle-js-overview-wrapper'>
            <div className="paddle-js-overview-title">{title}</div>
            <div className="paddle-js-overview-desc">{desc}</div>
            <img className="paddle-js-overview-image" src={image} alt={title} />
            <a href={bthLink} target="_blank" rel="noreferrer"> 
                <span className="paddle-js-overview-link">{btnWord}</span>
            </a>
        </div>
    );
};

export default PaddleJSOverview;